import React, {useMemo} from 'react';
import moment from "moment";
import {FormattedMessage} from "react-intl";
import {Typography} from "@mui/material";
import {useGetNFLPlayerGamesStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";

import './NFLGamesStats.style.scss';
import GlobalConst from "../../../constants/GlobalConst";
import NFLSeasonStats from "./NFLSeasonStats";
import {getCurrentSeasonYearsBySportAndSeason} from "../../../constants/SportsConst";
import "../PlayerGamesStats.style.scss";
const NFLGamesStats = ({contest}) => {

    const player = contest.player;

    const seasonYears = getCurrentSeasonYearsBySportAndSeason(4);

    const queryArgs = useMemo(() => ({
        playerId: player.PlayerId,
        from: moment().add(-1, 'weeks').toDate().getTime(),
        to: moment().add(1, 'days').endOf('day').toDate().getTime(),
        teamId: player.TeamId,
    }), [player.PlayerId, player.TeamId]);

    const {data: gameStats, isLoading} = useGetNFLPlayerGamesStatsByPlayerIdQuery(queryArgs);

    return <>
        {GlobalConst.FEATURES.SHOW_PLAYER_SEASON_STATS.NFL &&
            <NFLSeasonStats player={player} seasonYears={seasonYears}/>}
        <div className="NFLgameLogSection">
            <Typography variant="h6" className="gameLogTitle">
                {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.gameLog"}/>
            </Typography>
            <div className="NFLGamesStatsLog">
                <React.Fragment>
                    <div className="GameStats">
                        <div className="tableContainer">
                            <table className={"gameLogTable"}>
                                <thead>
                                <tr className='rowCat'>
                                    <th className="cat" colSpan={1}></th>
                                    <th className="cat" colSpan={4}>Passing</th>
                                    <th className="cat" colSpan={2}>Rushing</th>
                                    <th className="cat" colSpan={4}>Receiving</th>
                                    <th className="cat" colSpan={1}>Ret</th>
                                    <th className="cat" colSpan={1}>Misc</th>
                                    <th className="cat" colSpan={2}>Fumble</th>
                                </tr>
                                <tr className='rowHeader'>{
                                    <React.Fragment>
                                        <th>Date vs Opp</th>
                                        <th className={contest?.StatsKey === "Passing.Yards" ? "highlight gold-gradient-text" : ""}>Yds</th>
                                        <th className={contest?.StatsKey === "Passing.Touchdowns" ? "highlight gold-gradient-text" : ""}>TD</th>
                                        <th className={contest?.StatsKey === "Passing.Completions" ? "highlight gold-gradient-text" : ""}>C</th>
                                        <th className={contest?.StatsKey === "Interceptions" ? "highlight gold-gradient-text" : ""}>Int</th>
                                        <th>300+</th>
                                        <th className={contest?.StatsKey === "Rushing.Yards" ? "highlight gold-gradient-text" : ""}>Yds</th>
                                        <th className={contest?.StatsKey === "Rushing.Touchdowns" ? "highlight gold-gradient-text" : ""}>TD</th>
                                        <th className={contest?.StatsKey === "Receiving.Yards" ? "highlight gold-gradient-text" : ""}>Yds</th>
                                        <th className={contest?.StatsKey === "Receiving.Touchdowns" ? "highlight gold-gradient-text" : ""}>TD</th>
                                        <th className={contest?.StatsKey === "Receptions" ? "highlight gold-gradient-text" : ""}>Rec</th>
                                        <th>1OO+</th>
                                        <th>TD</th>
                                        <th>2PT</th>
                                        <th>Lost</th>
                                        <th>R.TD</th>
                                        <th className={contest?.StatsKey === "Sacks" ? "highlight gold-gradient-text" : ""}>Sck</th>
                                        <th className={contest?.StatsKey === "Tackles" ? "highlight gold-gradient-text" : ""}>Tkl</th>
                                    </React.Fragment>
                                }</tr>
                                </thead>
                                {gameStats?.filter((game) => moment(game.DateTime).isBefore(moment(), 'day'))
                                    .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                    .map((gameStats) => {

                                        return <tbody key={gameStats.GameId}>
                                        <tr>
                                            {
                                                <React.Fragment>
                                                    <td><span
                                                        className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                        <span className="vs"> vs {gameStats.Opponent} </span>
                                                    </td>
                                                    <td className={contest?.StatsKey === "Passing.Yards" ? "highlight gold-gradient-text" : ""}>{gameStats.PassingYard}</td>
                                                    <td className={contest?.StatsKey === "Passing.Touchdowns" ? "highlight gold-gradient-text" : ""}>{gameStats.PassingTouchdowns}</td>
                                                    <td className={contest?.StatsKey === "Passing.Completions" ? "highlight gold-gradient-text" : ""}>{gameStats.PassingCompletions}</td>
                                                    <td className={contest?.StatsKey === "Interceptions" ? "highlight gold-gradient-text" : ""}>{gameStats.PassingInterceptions}</td>
                                                    <td>{gameStats._300PlusYardPassingGame}</td>
                                                    <td className={contest?.StatsKey === "Rushing.Yards" ? "highlight gold-gradient-text" : ""}>{gameStats.RushingYards}</td>
                                                    <td className={contest?.StatsKey === "Rushing.Touchdowns" ? "highlight gold-gradient-text" : ""}>{gameStats.RushingTouchdowns}</td>
                                                    <td className={contest?.StatsKey === "Receiving.Yards" ? "highlight gold-gradient-text" : ""}>{gameStats.ReceivingYards}</td>
                                                    <td className={contest?.StatsKey === "Receiving.Touchdowns" ? "highlight gold-gradient-text" : ""}>{gameStats.ReceivingTouchdowns}</td>
                                                    <td className={contest?.StatsKey === "Receptions" ? "highlight gold-gradient-text" : ""}>{gameStats.Receptions}</td>
                                                    <td>{gameStats._100PlusReceivingYardsGames}</td>
                                                    <td>{gameStats.PuntKickFGReturnTouchdowns}</td>
                                                    <td>{gameStats.TwoPtsConvertion}</td>
                                                    <td>{gameStats.FumbleLost}</td>
                                                    <td>{gameStats.OffensiveFumbleRecevoryTouchdown}</td>
                                                    <td className={contest?.StatsKey === "Sacks" ? "highlight gold-gradient-text" : ""}>{gameStats.Sacks}</td>
                                                    <td className={contest?.StatsKey === "Tackles" ? "highlight gold-gradient-text" : ""}>{gameStats.Tackles}</td>
                                                </React.Fragment>
                                            }
                                        </tr>
                                        </tbody>
                                    })}
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </div>
    </>
};

export default NFLGamesStats;